export const STABLE_COINS = ['USDT','TUSD','USDC','BUSD']

export const cryptoFormatBalance = (value, currency) => {
  const [integerPart, decimalPart = ''] = value.toString().split('.')
  const isStable = STABLE_COINS.includes(currency.toUpperCase())

  let balance = Number(value)
  const integer = Number(integerPart)

  const stableCurrencyLength = 4
  const anyCurrencyLength = 8
  const minBalanceLength = 2
  const defaultBalance = 0

  const findFirstDecimal = decimalPart.match(/^0*(\d)/)
  const decimal = findFirstDecimal && findFirstDecimal[0]
  if (integer === 0 && decimal) {
    if (isStable && decimal.length <= stableCurrencyLength) {
      return `${integerPart}.${decimalPart.slice(0, stableCurrencyLength)}`
    }
    if (!isStable && decimal.length <= anyCurrencyLength) {
      return `${integerPart}.${decimalPart.slice(0, anyCurrencyLength)}`
    }
    return `${integerPart}.${decimal}`
  }
  if (integer > 0) {
    if (!decimalPart) {
      const bal = balance.toFixed(minBalanceLength)
      return bal
    }
    if (isStable && decimal && decimal.length > stableCurrencyLength) {
      const bal = balance.toFixed(minBalanceLength)
      return bal
    }
    if (!isStable && decimal && decimal.length > anyCurrencyLength) {
      const bal = balance.toFixed(minBalanceLength)
      return bal
    }
    if (isStable) {
      const bal =
        Math.floor(balance * Math.pow(10, stableCurrencyLength)) /
        Math.pow(10, stableCurrencyLength)

      return bal
    }
    if (!isStable) {
      const bal =
        Math.floor(balance * Math.pow(10, anyCurrencyLength)) / Math.pow(10, anyCurrencyLength)
      return bal
    }
  }
  return defaultBalance.toFixed(minBalanceLength)
}